import React from 'react';
import styles from '../../styles/AdminPage.module.css';

const AdminStats = ({ stats }) => {
  return (
    <div className={styles.stats}>
      <div className={styles.statCard}>
        <div className={styles.statValue}>{stats.total}</div>
        <div className={styles.statLabel}>Total Users</div>
      </div>
      <div className={styles.statCard}>
        <div className={styles.statValue}>{stats.approved}</div>
        <div className={styles.statLabel}>Approved (Page)</div>
      </div>
      <div className={styles.statCard}>
        <div className={styles.statValue}>{stats.pending}</div>
        <div className={styles.statLabel}>Pending (Page)</div>
      </div>
      <div className={styles.statCard}>
        <div className={styles.statValue}>{stats.admins}</div>
        <div className={styles.statLabel}>Admins (Page)</div>
      </div>
    </div>
  );
};

export default AdminStats;
